export default {"src":"/_next/static/media/AW-Service.a14b0956.svg","height":120,"width":200,"blurWidth":0,"blurHeight":0};